import { Transport, now, TransportTime, context, Reverb } from 'tone';

export const nativeAudioContext = (context.rawContext as any)._nativeAudioContext as AudioContext;

export function nextMeasureContextTime() {
    return Transport.nextSubdivision('1m');
}

export function nextBeatContextTime() {
    return Transport.nextSubdivision('16n');
}

export function nextQuarterContextTime() {
    return Transport.nextSubdivision('4n');
}

export function nextMeasureTransportTime() {
    let nextDelay = nextMeasureContextTime() - now();
    return transportTimeForDelay(nextDelay);
}

export function nextBeatTransportTime() {
    let nextDelay = nextBeatContextTime() - now();
    return transportTimeForDelay(nextDelay);
}

function transportTimeForDelay(delay: number) {
    let ticksFix = TransportTime(TransportTime(Transport.seconds)).toTicks() - Transport.ticks;
    let tickSeconds = 1 / Transport.PPQ * Transport.toSeconds('4n');
    return Transport.seconds + Math.max(0, delay) - ticksFix * tickSeconds;
}

export function nextBeat() {
    let posSeconds = TransportTime(Transport.position).toSeconds();
    let beatSeconds = TransportTime('16n').toSeconds();
    let posBeats = posSeconds / beatSeconds;
    return Math.ceil(posBeats);
}

export function setBpm(bpm: number) {
    Transport.bpm.value = bpm;
}

let reverbWet = nativeAudioContext.createGain();
reverbWet.gain.value = 0.3;
let reverbDry = nativeAudioContext.createGain();
reverbDry.gain.value = 1.0;
let reverb = nativeAudioContext.createConvolver();
let reBuf = new Reverb({ decay: 1.5 });
reBuf.generate().then(() => reverb.buffer = (reBuf as any)._convolver.buffer);


export const wetDest = nativeAudioContext.createGain();

export const dryDest = nativeAudioContext.createGain();
dryDest.gain.value = 0.8;

wetDest.connect(reverbWet);
wetDest.connect(reverbDry);

reverbWet.connect(reverb);
reverb.connect(dryDest);
reverbDry.connect(dryDest);
dryDest.connect(nativeAudioContext.destination);



